import { store } from '~/store/configureStore';
import { TRootState } from '~/store/types';
import { hasChildOffices } from './OfficeUtils';

export const UserUtils = {
  /**
   * Checks if the current user is viewing as a parent office.
   * Returns true when: the account has child offices AND the parent office is currently selected.
   */
  isParentOffice: () => {
    const {
      childOffices,
      selectedChildOffice,
      user: currentLoggedUser,
    } = (store.getState() as TRootState).user;

    const isSelectedOfficeSameWithLoggedUser = selectedChildOffice?.id === currentLoggedUser?.id;

    return hasChildOffices(childOffices) && isSelectedOfficeSameWithLoggedUser;
  },
};
